import { AUTH_STATE_COOKIE, LEARNER_TOKEN_COOKIE, getCookie } from "@app/utils/api";

/**
 * Whether a learner session exists, without reading the token (VAPT #11: cookies without HttpOnly).
 *
 * The learner token cookie is HttpOnly, so `getCookie("token")` answers `null` for a perfectly
 * healthy session. Anything that used the token's presence as "is the user signed in?" would decide
 * "signed out" and bounce a live session to the login page — which is what the two form renderers
 * used to do. `authState` is the readable flag core-api sets beside the token for this question.
 *
 * The token fallback is transitional, mirroring lms-frontend's `isAuthenticated()`: sessions created
 * before the rollout carry no `authState`, and they must not be logged out. It can go once the token
 * is HttpOnly everywhere, at which point it can never be true.
 *
 * Note this is a client-side check only — `getCookie` reads `document.cookie` and returns `null`
 * during SSR, so callers must run it in an effect or an event handler, never at module scope.
 */
export const isAuthenticated = (): boolean => Boolean(getCookie(AUTH_STATE_COOKIE)) || Boolean(getCookie(LEARNER_TOKEN_COOKIE));
